import { render } from "./SearchComponent.vue?vue&type=template&id=b4dbab8c"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/SearchComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4dbab8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4dbab8c', __exports__)) {
    console.log('reload')
    api.reload('b4dbab8c', __exports__)
  }
  
  module.hot.accept("./SearchComponent.vue?vue&type=template&id=b4dbab8c", () => {
    console.log('re-render')
    api.rerender('b4dbab8c', render)
  })

}


export default __exports__